import React, {Component, Fragment} from 'react';
import Hero from '../Components/Hero'
import Intro from '../Components/Intro'
// import AboutSpeaker from '../Components/AboutSpeaker'
import TimeTable from '../Components/TimeTable'
import AboutActivity from '../Components/AboutActivity'
import SupportUS from '../Components/SupportUS'
import './Home.css';

class Home extends Component {
    state = {
        isShow: false
    };

    render() {
        return (
            <Fragment>
                <Hero />
                <Intro />
                {/*<AboutSpeaker/>*/}
                <TimeTable />
                <AboutActivity />
                <SupportUS/>
            </Fragment>
        );
    }

}

export default Home;
